import settings from '@/settings'

const pushNotification = (data, posto, headers) => {
  return fetch(`${settings.apetrusApi}/notificacoes/push/?posto=${posto}`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

export default {
  pushNotification
}
